export default {
  'processes.title': 'Procesos',
  'processes.start.title': 'Iniciar Solicitud',
  'processes.tab.groups': 'Grupos',
  'processes.tab.favorites': 'Favoritos',
  'processes.tab.list': 'Procesos',
  'processes.form.processGroup': 'Grupo de Procesos',
  'processes.form.startMode': 'Modo de inicio',
  'processes.form.instancesNamePattern': 'Patrón Nombre Solicitudes',
  'processes.form.lastGeneratedNumber': 'Último Número Generado',
  'processes.form.isPublicProcess': '¿Público?',
  'processes.form.isNotificationsEnabled': '¿Notificaciones Habilitadas?',
  'processes.form.notificationsFrequency': 'Frecuencia de Notificaciones',
  'processes.form.notificationsFrequencyValue': 'Valor Frecuencia Notificaciones',
  'processes.form.startFrequency': 'Frecuencia Inicio',
  'processes.form.startFrequencyValue': 'Valor Frecuencia Inicio',
  'processes.form.startDate': 'Fecha Inicio',
  'processes.form.lastStartDate': 'Última Fecha Iniciado',
  'processes.form.isDeadlineEnabled': '¿Habilitar Control de Limite de Tiempo de Ejecucion?',
  'processes.form.deadlineMeasureUnit': 'Unidad de Control de Tiempo',
  'processes.form.deadlineMeasureValue': 'Valor de Control de Tiempo',

  'processes.form.isRequestsLimitEnabled': '¿Controlar Cantidad de Solicitudes Permitidas?',
  'processes.form.requestsLimit': 'Cantidad de Solicitudes Permitidas',
  'processes.form.maxRejectionCount': 'Máximo Número de Rechazos',
  'processes.form.automaticNumbersCurrentYear': 'Números Automáticos Año Actual',
  'processes.form.automaticNumbersCurrentMonth': 'Números Automáticos Mes Actual',
  'processes.form.automaticNumbersCurrentDay': 'Números Automáticos Día Actual',
  'processes.form.disableSendApprovedRequestMailAtEnd':
    'Deshabilitar Envío de Correo de Solicitud Aprobada al Final',
  'processes.form.disableSendRejectedRequestMailAtEnd':
    'Deshabilitar Envío de Correo de Solicitud Rechazada al Final',
  'processes.form.isSendErrorNotificationsEnabled': '¿Habilitar Notificaciones de Error?',
  'processes.form.isBulkRequestCreationEnabled': '¿Habilitar Creación Masiva de Solicitudes?',
  'processes.form.isAllowViewWithoutAuthenticatingEnabled':
    '¿Permitir Visualización Sin Autenticación?',
  'processes.form.isAllowApprovalWithoutAuthenticatingEnabled':
    '¿Permitir Aprobación Sin Autenticación?',
  'processes.form.disableRequestCancellation': 'Deshabilitar Cancelación de Solicitudes',
  'processes.form.commentsAccessMode': 'Modo de Acceso a Comentarios',
  'processes.form.commentsAccessMode.disabled': 'Deshabilitado',
  'processes.form.commentsAccessMode.readOnly': 'Solo lectura',
  'processes.form.commentsAccessMode.appendOnly': 'Solo agregar (sin editar ni eliminar)',
  'processes.form.commentsAccessMode.delete': 'Solo eliminar (moderación)',
  'processes.form.commentsAccessMode.edit': 'Editar (sin eliminar)',
  'processes.form.commentsAccessMode.editAndDelete': 'Editar y eliminar',
  'processes.form.isShowPercentEnabled': '¿Mostrar Porcentaje de Progreso?',
  'processes.form.percentActionsCount': 'Cantidad de Acciones para Porcentaje',
  'processes.form.offlineEnabled': 'Habilitar Modo Offline',

  // Wizard Steps
  'processes.wizard.steps.basicInformation': 'Información Básica',
  'processes.wizard.steps.namePatterns': 'Patrones de Nombres',
  'processes.wizard.steps.notificationSettings': 'Configuración de Notificaciones',
  'processes.wizard.steps.startMode': 'Modo de Inicio',
  'processes.wizard.steps.requestsLimitDeadline': 'Límites y Plazos',
  'processes.wizard.steps.others': 'Otras Configuraciones',

  'processes.select.instant': 'Flujo Manual',
  'processes.select.automated': 'Flujo Automatizado',
  'processes.select.scheduled': 'Flujo Programado',

  'processes.configure.title': 'Configurar Proceso',
  'process.SearchInput.placeholder': 'Buscar Configuración',

  'process.text.fileName': 'Nombre',
  'process.text.userCreator': 'Autor',
  'process.text.contentType': 'Tipo de Archivo',
  'process.text.options': 'Opciones',
  'process.text.processGroups': 'Grupo de Procesos',
  'process.text.processPortal': 'Portal de Procesos',
  'process.text.completed': 'Ejecutado',
  'process.text.manually': 'Manual',
  'process.text.automatic': 'Automático',
  'process.text.schedule': 'Programado',

  'process.text.reportName': 'Nombre',
  'process.text.reportType': 'Tipo',
  'process.text.listName': 'Nombre',
  'process.text.listType': 'Tipo',
  'process.text.portalName': 'Nombre',
  'process.text.portalCode': 'Code',

  'process.button.bulk.upload': 'Cargar formato Excel Solicitudes',
  'process.button.bulk.label': 'Haz clic para cargar',

  'process.text.bulk.download': 'Formato Excel para carga masiva de solicitudes',
  'process.text.bulk.upload': 'Carga masiva Excel para solicitudes',
  'process.text.bulk.isScheduledProcessingEnabled': '¿Habilitar Fecha de Procesamiento Programada?',
  'process.text.bulk.attachments': 'Documento Excel',
  'process.text.bulk.scheduledProcessingDate': 'Fecha de Procesamiento Programada',
  'process.text.bulk.download.loading': 'Descargando Plantilla de Solicitudes...',
  'process.text.bulk.download.success': 'Plantilla de Solicitudes descargado correctamente.',

  'process.text.reports.reportType1': 'Administración',
  'process.text.reports.reportType2': 'Procesos',
  'process.text.reports.reportType3': 'Solicitud',
  'process.text.reports.reportType4': 'Genérico',
  'process.text.reports.reportType5': 'Conector PowerBI',

  'process.text.lists.listType1': 'Lista',
  'process.text.lists.listType2': 'Gant',
  'process.text.lists.listType3': 'Calendario',
  'process.text.lists.listType4': 'Tareas',
  'process.text.lists.listType6': 'Tarjetas',
  'process.text.lists.listType7': 'Mapa',
  'process.canvas.note.placeholder': 'Como una nota...',
  'process.approval.card.general.description': 'Configuración general de aprobación',
  'process.approval.card.rejection.description': 'Configuración de rechazo y control de rechazos',
  'process.approval.card.deadline.description': 'Control de límite de tiempo de ejecución',
  'process.approval.card.filters.general.description':
    'Configuración general de filtros de aprobadores',
  'process.approval.card.filters.users.description': 'Filtrar aprobadores por usuarios específicos',
  'process.approval.card.filters.positions.description': 'Filtrar aprobadores por puestos',
  'process.approval.card.filters.areas.description': 'Filtrar aprobadores por áreas',
  'process.approval.card.filters.userGroups.description':
    'Filtrar aprobadores por grupos de usuarios',
  'process.approval.card.filters.externalUsers.description':
    'Filtrar aprobadores por usuarios externos',
  'process.approval.card.filters.agents.description': 'Filtrar aprobadores por agentes IA',
  'process.approval.card.filters.userExtraFields.description':
    'Filtrar aprobadores por campos extra de usuario',
  'process.approval.card.filters.global.description':
    'Configurar filtros globales de aprobadores (7 sub-grupos)',
  'process.approval.card.filters.formField.description':
    'Filtrar aprobadores por campos de formulario (4 sub-grupos)',
  'process.approval.filters.externalUsers.alert.title': 'Configuración simplificada',
  'process.approval.filters.externalUsers.alert.description':
    'Esta es una versión simplificada que maneja un único filtro de usuario externo. Para la gestión completa de múltiples elementos, usa la implementación con lista y drawer.',
  'process.approval.filters.userExtraFields.alert.title': 'Configuración simplificada',
  'process.approval.filters.userExtraFields.alert.description':
    'Esta es una versión simplificada que maneja un único filtro de campo extra de usuario. Para la gestión completa de múltiples elementos, usa la implementación con lista y drawer.',

  'process.v1ConfigURL.noURL': 'No se proporcionó URL de configuración',
};
